import * as v from "valibot";

// request schema
export const ComponentsLimitSchema = v.object({
  ComponentType: v.string(),
  Cpu: v.number(),
  Memory: v.number(),
});
export type ComponentsLimit = v.InferOutput<typeof ComponentsLimitSchema>;

export const RequestSchema = v.object({
  ClusterId: v.string(),
  ComponentsLimit: v.array(ComponentsLimitSchema),
  EndTime: v.string(),
  MaintenanceCycle: v.array(v.string()),
  StartTime: v.string(),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response schema
export const DataSchema = v.object({
  ClusterId: v.string(),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
